import { AppHeaderContext } from '@deltek/specification-client/core/Contexts/AppHeaderContext'
import BanneredPage from 'bpm/pages/components/BanneredPage'
import React from 'react'
import ProductHeader from '../components/ProductHeader'

const CompetitiveAnalysisPage: React.FC = () => {
    const { updateAppHeaderContent } = React.useContext(AppHeaderContext)

    React.useEffect(() => {
        updateAppHeaderContent('Competitive Analysis', <ProductHeader />)
    }, [updateAppHeaderContent])

    return (
        <BanneredPage heading="Competitive Analyis">
            Competitive Analysis Page
        </BanneredPage>
    )
}

export default CompetitiveAnalysisPage
